import { put, takeEvery } from 'redux-saga/effects'
import { ORDERLOCATIONS_LOADING, ORDERLOCATIONS_SUCCESS, ORDERLOCATIONS_ERROR } from "../actions/actionOrderLocations";
import { getOrderLocationsByDisplayArea } from 'api'

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    else if (response.status == 400) {
        throw await response.json();
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get Order Locations, response status: " + response.status + "\"}]}")
    }
}

function* fetchOrderLocationsByDisplayArea(action) {
    try {
        const data = yield fetchAsync(getOrderLocationsByDisplayArea, action.payload)
        if (data == "nocontent") throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"No Order Locations were found.\"}]}")
        else {
            yield put({ type: ORDERLOCATIONS_SUCCESS, payload: data });
        }
    } catch (e) {
        yield put({ type: ORDERLOCATIONS_ERROR, error: e });
    }
}

export const sagaOrderLocations = [
    takeEvery(ORDERLOCATIONS_LOADING, fetchOrderLocationsByDisplayArea)
];
